import { Model } from '@/models/Model';

export class Rapportage extends Model {
  protected $name = 'Rapportage';

  protected $endpoint = '/hin/dashboard';

  public total_reports?: number;

  public total_planned_reports?: number;

  public total_still_liable?: number;

  public total_not_liable_anymore?: number;

  public total_in_progress?: number;

  public total_at_contractor?: number;

  public total_closed_reports?: number;

  public total_average_review_contractors?: number;

  public total_average_review_procedures?: number;

  public listRapportage(payload: Record<string, string>): Promise<any> {
    return this.request('get', this.$endpoint, payload);
  }
}
